/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Config from 'config'

export default {
  storeviewID (state) {
    return state.id
  },
  websiteId (state) {
    return state.config.website_id
  },
  rootCategoryId (state) {
    return state.config.root_category_id
  },
  metaTitle (state) {
    return state.config.default_title
  },
  metaDescription (state) {
    return state.config.default_description
  },
  metaKeyword (state) {
    return state.config.default_keywords
  },
  locale (state) {
    return state.config.locale
  },
  currencyCode (state) {
    return state.config.base_currency_code
  },
  language (state) {
    if (state.config.locale) {
      return state.config.locale.substr(0, 2)
    }
    return ''
  },
  newsletterSettings (state) {
    if (state.config) {
      return state.config.newsletterSettings
    }
    return {}
  },
  basePathLang (state) {
    return `${state.baseUrl}/${state.config.code}/`
  },
  homePage (state) {
    return state.config.cms_home_page || 'home'
  },
  paypal_sandbox (state) {
    return state.config.paymentMethodSettings ? state.config.paymentMethodSettings.paypalConfig.mode !== '0' : true
  },
  paypalExpressURL (state) {
    // const merchant = state.config.paymentMethodSettings ? state.config.paymentMethodSettings.paypalConfig.merchant : ''
    const merchant = process.env.VUE_APP_PAYPAL_MERCHANT
    return Config.Theme.paypalExpress.url.replace('{{merchant}}', merchant)
  }
}
